import React from 'react'
import { ExternalLink, Edit, Trash2, Video, FileText, Book, Microscope } from 'lucide-react'
import './MaterialCard.css'

const MaterialCard = ({ material, onEdit, onDelete, isOwner }) => {
    const getIcon = (type) => {
        switch (type) {
            case 'video':
                return <Video size={20} />
            case 'ejercicio':
                return <FileText size={20} />
            case 'libro':
                return <Book size={20} />
            case 'simulador':
                return <Microscope size={20} />
            default:
                return <FileText size={20} />
        }
    }

    const getTypeLabel = (type) => {
        const labels = {
            video: 'Video',
            ejercicio: 'Ejercicio',
            libro: 'Libro',
            simulador: 'Simulador'
        }
        return labels[type] || type
    }

    return (
        <div className="material-card">
            <div className="material-card-header">
                <div className="material-type">
                    {getIcon(material.type)}
                    <span>{getTypeLabel(material.type)}</span>
                </div>
                {isOwner && (
                    <div className="material-actions">
                        <button
                            className="icon-btn edit"
                            onClick={() => onEdit(material)}
                            title="Editar"
                        >
                            <Edit size={16} />
                        </button>
                        <button
                            className="icon-btn delete"
                            onClick={() => onDelete(material.id)}
                            title="Eliminar"
                        >
                            <Trash2 size={16} />
                        </button>
                    </div>
                )}
            </div>

            <h4 className="material-title">{material.title}</h4>

            {material.description && (
                <p className="material-description">{material.description}</p>
            )}

            <a
                href={material.url}
                target="_blank"
                rel="noopener noreferrer"
                className="material-link"
            >
                <ExternalLink size={16} />
                Abrir recurso
            </a>
        </div>
    )
}

export default MaterialCard
